module.exports = __webpack_public_path__ + "static/chardalyn_dragon-672debf2aeed24f0d62b433bccc2ccfe.jpeg";